import React from 'react'
import TextField from '../../Reusable/Form/TextInput'

const VehicleForm = ({ register, errors, setValue, getValues, clearErrors }: any) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
      <TextField
        label={"Emergency Contact Number"}
        register={register("emergency_contact_number")}
        errors={errors?.emergency_contact_number}
      />
      <TextField
        label={"Vehicle Number"}
        register={register("license_number")}
        errors={errors?.license_number}
      />
      {/* <TextField
        label={"Insurance Date"}
        register={register("insurance_date")}
        errors={errors?.insurance_date}
      />
      <TextField
        label={"Permit Date"}
        register={register("permit_date")}
        errors={errors?.permit_date}
      /> */}
      <TextField
        label={"Insurance Comapny"}
        register={register("insurance_company")}
        errors={errors?.insurance_company}
      />
      <TextField
        label={"Insurance Company Contact Number"}
        register={register("insurance_company_contact_number")}
        errors={errors?.insurance_company_contact_number}
      />
      <TextField
        label={"Samiti Name"}
        register={register("samiti_name")}
        errors={errors?.samiti_name}
      />
      <TextField
        label={"Samiti Contact Number"}
        register={register("samiti_contact_number")}
        errors={errors?.samiti_contact_number}
      />
      <TextField
        label={"Chaises No."}
        register={register("chaises_no")}
        errors={errors?.chaises_no}
      />
    </div>
  )
}

export default VehicleForm
